import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import { Routes, Route } from 'react-router-dom';
import Products from './pages/Products';
import Cart from './pages/Cart';
import About from './pages/About';
import Privacy from './pages/Privacy';
import ProductsContextProvider from './context/products-context';
import PrivacyDisclosureBanner from './components/PrivacyDisclosureBanner';

function App() {
  return (
    <ProductsContextProvider>
      <CssBaseline />
      <Routes>
        <Route index element={<Home/>} />
        <Route path="products" element={<Products/>} />
        <Route path="about" element={<About/>} />
        <Route path="privacy" element={<Privacy/>} />
        <Route path="cart" element={<Cart/>} />
        <Route path="*" element={<NotFound/>} />
      </Routes>
      <PrivacyDisclosureBanner />
    </ProductsContextProvider>
  );
}

export default App;
